import { prefix } from '../../utils/prefix';

const Url = {
  getInfo: `${prefix}/info/worksInfo/get`,
  saveDraft: `${prefix}/draft/worksInfo/save`,
  save: `${prefix}/info/worksInfo/save`,
  validate: `${prefix}//info/worksInfo/validateWorksInfo`,
  ocrUpLoad: `${prefix}/attachment/ocrUpLoad/25`, // 上传离职证明
  getOutOfWorkType: `${prefix}/info/worksInfo/getOutOfWorkReason`, // 获取歇业类型
  getWorkType: `${prefix}/info/workerType`, // 获取员工类型
  getJoinDate: `${prefix}/info/basicInfo/get`, // 通过获取基本信息接口获取入职日期
  getNoProveReasons: `${prefix}/info/worksInfo/getNoProveReasons`, // 获取离职证明的类型
  getLeaveReasons: `${prefix}/info/worksInfo/getLeaveReasons`,
  getNationality: `${prefix}/dataset/nationality`, // 获取国家
  upload: `${prefix}/attachment/upload/21`, // 附件上传
  delete: `${prefix}/attachment/delete`, // 附件删除
};

export default Url;
